import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'iconsax-react'
import TopbarProfile from './TopbarProfile'

interface IProps {
  toggleSidebar?: () => void
  title?: string
  isBackNav?: boolean
}

function Topbar(props: IProps) {
  const navigate = useNavigate()

  const handleNavigateBack = () => {
    navigate(-1)
  }

  return (
    <div data-testid="topbar" className="topbar">
      <div
        data-testid="sidebar-toggler"
        onClick={props.toggleSidebar}
        className="topbar__sidebar-toggler"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className="flex gap-2">
        {props.isBackNav ? (
          <ArrowLeft
            data-testid="button_back_nav"
            size="24"
            color="#858C95"
            onClick={handleNavigateBack}
            className="hover:cursor-pointer"
          />
        ) : null}
        <h4 className="topbar__title">{props.title}</h4>
      </div>
      <TopbarProfile />
    </div>
  )
}

export default Topbar
